export interface TemplatePermissions {
  // Admin-only actions. Standard users can still load/use templates on a contract (see
  // `applyTemplateToSpec` in `specFormSlice.ts`) — they just can't create, edit, delete, or
  // duplicate the templates themselves.
  canManageTemplates: boolean;
}

/**
 * Central place for the Template Manager's role-based UI checks.
 *
 * The Pricing Engine reference app read `hostServices.auth.user.roles`, supplied by a generic
 * MFE shell. Contract Entry has no such shell — it authenticates directly against Cognito via
 * `AuthGate` (see `services/ui/src/app/auth/AuthGate.tsx`) with no per-user role claims surfaced to
 * the UI yet — so every signed-in user is treated as a template admin for now. This hook remains
 * the sole place to change once Contract Entry has its own role model to gate against.
 */
export const usePermissions = (): TemplatePermissions => ({ canManageTemplates: true });
